export default "__VITE_ASSET__e86a179e__"